// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TextList, Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
let TeaserBoxInnerGridL5STextList = class TeaserBoxInnerGridL5STextList extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            [TileSize.S]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: false,
                showAuthorName: false,
                showCategory: false,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.S,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            },
            [TileSize.L]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
                showAuthorName: this.teaserBoxConfig.showAuthorName,
                showCategory: this.teaserBoxConfig.showCategory,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.L,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            }
        };
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.TileSize = TileSize;
    }
};
TeaserBoxInnerGridL5STextList.moduleVersion = TeaserBoxVersion['L-5S-text-list'];
TeaserBoxInnerGridL5STextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL5STextList',
        components: { InnerGridWrapper, TextList, Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tile / L -->
        <Tile v-bind="{ ...tileConfig[TileSize.L], fallbackImage, windowService, isLazy, isMobile }"
              :article="articles[0]" :title-on-image="false" />

        <!-- Tiles / S -->
        <Tile v-for="article in articles.slice(1, 6)" :key="article.id"  :title-on-image="false"
              v-bind="{ ...tileConfig[TileSize.S], article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- TextList -->
        <div class="teaser-box__list-wrapper-three-rows">
          <TextList v-bind="{ readMoreLink, listConfig }" :articles="articles.slice(6)"
                    :without-badge="true" :show-publication-date="true" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridL5STextList);
export { TeaserBoxInnerGridL5STextList };
